import { ButtonPlugin, Events, bindEvent } from 'paella-core';

import cinemaModeIcon from "../icons/cinemamode.svg";
import cinemaModeExitIcon from "../icons/cinemamodeExit.svg";


export default class cinemaModeButton extends ButtonPlugin {
    getAriaLabel() {
        return 'Cinema mode';
    }

    getDescription() {
        return this.getAriaLabel();
    }

    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    eraseCookie(name) {   
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    async getDictionaries() {
        return {
            hu: {
                "Cinema mode": "Mozi mód"
            }
        }
    }

    async isEnabled() {

        const enabled = await super.isEnabled();

        return enabled && !this.player.isFullscreen;
    }

    async load() {
        this.icon = cinemaModeIcon;

        //Hide button when fullscreen
        bindEvent(this.player, Events.FULLSCREEN_CHANGED, (data) => {
            if(data.status)
            {
                this.container.style.display = "none";

            }else
            {
                this.container.style.display = "inline";
            }    
		});

        /*
        const cinemamode = localStorage.getItem("cinemamode");

        if(cinemamode === "on" && !document.body.classList.contains('player-cinemamode'))
        {
            document.body.classList.add('player-cinemamode');
            this.icon = cinemaModeExitIcon;
            this.player.resize();
        }
        else if(cinemamode === "off" && document.body.classList.contains('player-cinemamode'))
        {
            document.body.classList.remove('player-cinemamode');
            this.icon = cinemaModeIcon;
            this.player.resize();
        }
        */

    }

    async action() {

        if (document.body.classList.contains('player-cinemamode')) {

            document.body.classList.remove('player-cinemamode');
            this.icon = cinemaModeIcon;

            // localStorage.setItem("cinemamode", "off");

            this.eraseCookie('player-cinemamode');
        }
        else {

            document.body.classList.add('player-cinemamode');
            this.icon = cinemaModeExitIcon;

            // localStorage.setItem("cinemamode", "on");
            this.setCookie('player-cinemamode', true);
        }

        this.player.resize();
    }
}
